import { PropTypes } from "prop-types";
import { useEffect } from "react";

import GlobalContainer from "../global_container";

const BlankPage = ({ title = "Brokerkit", children = null, showHeader = true }) => {
  useEffect(() => {
    document.title = title || "Brokerkit";
  }, [title]);

  return (
    <GlobalContainer showHeader={showHeader}>{children}</GlobalContainer>
  );
};

BlankPage.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  showHeader: PropTypes.bool,
};

export default BlankPage;
